import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Company } from '../../../core/services/companies/models/company.model';
import { select, Store } from '@ngrx/store';
import { selectCompanies, selectLoadingCompanies, selectSelectedCompany, selectYear } from '../../../core/state/company/company-context.selectors';
import { changeSelectedCompany, changeYear } from '../../../core/state/company/company-context.actions';
import { SelectChangeEvent } from 'primeng/select';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-company-select',
    templateUrl: './company-select.component.html',
    styleUrl: './company-select.component.css',
    standalone: false
})
export class CompanySelectComponent implements OnInit, OnDestroy {

  companies: Company[] = [];
  loadingCompanies$ = this.store.pipe(select(selectLoadingCompanies));
  selectedCompany$: Observable<Company | null> = this.store.pipe(select(selectSelectedCompany));
  selectedYear$: Observable<number | null> = this.store.pipe(select(selectYear));

  availableYears = Array.from(
    { length: new Date().getFullYear() - 2020 },
    (_, i) => 2021 + i
  );

  form: FormGroup;

  yearEvent: SelectChangeEvent | undefined;

  private destroy$ = new Subject<void>();

  constructor(
    private translate: TranslateService,
    private store: Store
  ) {
    this.form = new FormGroup({
      year: new FormControl(new Date().getFullYear())
    });
  }

  ngOnInit() {
    this.store.pipe(
      select(selectCompanies),
      takeUntil(this.destroy$)
    ).subscribe(companies => {
      this.companies = companies || [];
    });

    this.selectedYear$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(year => {
      if (year !== null) {
        this.form.get('year')?.setValue(year, { emitEvent: false });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onChangeCompany(event: Company) {
    this.store.dispatch(changeSelectedCompany({ item: event }));
    if (this.yearEvent) {
      this.onChangeYear(this.yearEvent);
    }
  }

  onConfigureCompanies() {
    window.open(`${environment.adminPanelUrl}/companies`, '_blank');
  }

  navigateToManagement() {
    window.open(`${environment.adminPanelUrl}/companies`, '_blank');
  }

  onChangeYear(event: SelectChangeEvent) {
    this.yearEvent = event;
    this.store.dispatch(changeYear({ year: event.value }));
  }

}
